<template>
	<div class="page">
		<top-header></top-header>
		<!--<h1 class="mt-2 text-center">Smart City</h1>-->
		<p class="text-center mt-3">Welcome to Smart Street Light Controller DashBoard</p>
		<b-container fluid>
			<b-row>
				<b-col>
					<b-link href="/state-dashboard/in-up">
						<div style="padding:0px 20%;">
							<b-img src="../assets/in-up.svg" center  fluid ></b-img>
						</div>
						<h4 class="text-center">Uttar Pradesh</h4>
					</b-link>
				</b-col>
				<b-col>
					<b-link href="/state-dashboard/in-mh">
						<div style="padding:4.5% 20%;">
							<b-img src="../assets/in-mh.svg" center  fluid ></b-img>
						</div>
						<h4 class="text-center">Maharashtra</h4>
					</b-link>
				</b-col>
				<b-col>
					<b-link href="/state-dashboard/in-dl">
						<div style="padding:4.5% 20%;">
							<b-img src="../assets/in-dl.svg" center  fluid ></b-img>
						</div>
						<h4 class="text-center">Delhi</h4>
					</b-link>
				</b-col>
				<b-col>
					<b-link href="/state-dashboard/in-rj">
						<div style="padding:4.5% 20%;">
							
						</div>
						<h4 class="text-center">Rajasthan</h4>
					</b-link>
				</b-col>
				<b-col>
					<b-link href="/state-dashboard/in-rh">
						<div style="padding:4.5% 20%;">
							
						</div>
						<h4 class="text-center">Rachi Demo</h4>
					</b-link>
				</b-col>
			</b-row>
		</b-container>
		<top-footer></top-footer>
		<search-sidebar></search-sidebar>
	</div>
</template>
<script>
import Header from "@/components/Header.vue";
import Search from "@/components/Search.vue";
export default {
	name: 'Login',
	components: {
		"top-header": Header,
		"search-sidebar": Search
	},
	beforeCreate: function() {
        document.body.className = 'page';
    },
	mounted(){
		this.initload();
	},
	data() {
		var self = this;
		return{
			email: '',
			password: '',
			url: self.$session.get('apiurl')+'bareillyapi/dashboard'
		};
	},
	methods: {
		initload(){
			var self = this;
			self.axios.post(self.url, {
				accesskey: self.$session.get('access_key')
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.devices = response.data.result.devices;
					self.controllers = response.data.result.controllers;

					self.dashboard_data = response.data.result;
					self.records = response.data.result.records;
					self.zones = response.data.result.zones;

					self.totalRows = self.records.length;

					self.total_device = 0;
					self.total_device_on = 0;
					self.total_device_off = 0;
					self.total_device_loss = 0;

					self.total_controller = 0;
					self.total_controller_on = 0;
					self.total_controller_off = 0;
					self.total_controller_loss = 0;
					
					self.connected_devices = 0;
					self.poweroff_devices = 0;

					self.records.forEach(function(item){
						self.total_controller += item.total_controller;
						self.total_device += item.total_device;
						self.total_device_loss += item.total_device_loss;
						self.total_controller_on += item.total_controller_on;
						self.total_controller_off += item.total_controller_off;
						self.total_controller_loss += item.total_controller_loss;

						self.poweroff_devices += item.total_powercut;
					});
					self.total_device_on = self.total_device - self.total_device_loss;
					
					setTimeout(self.initload, 1000*30);
					//alert(JSON.stringify(response.data.result.devices));
				}
				
			})
			.catch(function (error) {
				alert(error);
			});
			//alert('login '+self.email+" "+self.password);
		},
		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length
			this.currentPage = 1
		}
	}
}
</script>
<style>
html{
	min-height: 100%;
}
body{
	background-color: '#FFF' !important;
	background-image: none !important;
}
.table{
	font-size: small;
}
.table .btn{
	font-size: 12px;
}
.table td, .table th{
	vertical-align: middle;
}

.mt-xl{
	margin-top: 100px;
}
.btn-black{
	background-color: #000;
	color: #FFF;
	padding: 6px 25px;
}
.info-box2{
	display: block;
	min-height: 90px;
	background-color: #FFF;
	width: 100%;
	box-shadow: 0 1px 1px rgba(0,0,0,0.1);
	border-radius: 2px;
    margin-bottom: 15px;
}

</style>